module.exports = __webpack_public_path__ + "static/media/ZAMORA-DRYWALL-INC-wh.d9a88eee.png";